/**
 * Compact Discovery `.fcard` (Highlights + A–Z rails).
 *
 * Two named widths — one per viewport band. Never mix widths in the same band.
 * Image crop aspect stays 230/172 for both.
 *
 * Breakpoint `COMPACT_VENUE_CARD_MQ_MAX` (399.98px): phone portrait. Below it,
 * A–Z gets 2 full columns at NARROW; at/above it, DEFAULT 256×342 (Step 3).
 */
export const COMPACT_VENUE_CARD_ASPECT_W = 172;
export const COMPACT_VENUE_CARD_ASPECT_H = 230;

/** CSS px — use with `(max-width: ${COMPACT_VENUE_CARD_MQ_MAX}px)`. */
export const COMPACT_VENUE_CARD_MQ_MAX = 399.98;

export const COMPACT_VENUE_CARD_WIDTH = 256;
export const COMPACT_VENUE_CARD_HEIGHT = Math.round(
  (COMPACT_VENUE_CARD_WIDTH * COMPACT_VENUE_CARD_ASPECT_H) / COMPACT_VENUE_CARD_ASPECT_W,
); // 342

/**
 * Phone-portrait width: fits 2 full A–Z columns at 390px
 * (`(390 - 8 pad - 12 gap) / 2 = 185`).
 */
export const COMPACT_VENUE_CARD_WIDTH_NARROW = 185;
export const COMPACT_VENUE_CARD_HEIGHT_NARROW = Math.round(
  (COMPACT_VENUE_CARD_WIDTH_NARROW * COMPACT_VENUE_CARD_ASPECT_H) /
    COMPACT_VENUE_CARD_ASPECT_W,
); // 247 — two-line meta fits without growing the box (measured)

/** `sizes` for compact EventImage — matches CSS media query. */
export const COMPACT_VENUE_CARD_SIZES = `(max-width: ${COMPACT_VENUE_CARD_MQ_MAX}px) ${COMPACT_VENUE_CARD_WIDTH_NARROW}px, ${COMPACT_VENUE_CARD_WIDTH}px`;
